/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Missing_2Inputs */

const en_vc_status_missing_2 = /** @type {(inputs: Vc_Status_Missing_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripting and plugins`)
};

const zh_vc_status_missing_2 = /** @type {(inputs: Vc_Status_Missing_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚本和插件`)
};

/**
* | output |
* | --- |
* | "Scripting and plugins" |
*
* @param {Vc_Status_Missing_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_missing_2 = /** @type {((inputs?: Vc_Status_Missing_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Missing_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_missing_2(inputs)
	return zh_vc_status_missing_2(inputs)
});
export { vc_status_missing_2 as "vc.status.missing.2" }